import { css } from '@emotion/css';
import { type ComboboxItem, type ComboboxLikeRenderOptionInput, Group, Text } from '@mantine/core';

import type { ComboboxItemWithIcon } from '../../controller/condition-fields-constants';

export function renderFieldItem(input: ComboboxLikeRenderOptionInput<ComboboxItem>) {
  const item = input.option as ComboboxItemWithIcon;
  return (
    <Group wrap="nowrap">
      {item.icon}
      <Text size="sm">{item.label}</Text>
    </Group>
  );
}

export const selectedFieldStyle = css`
  &:not(:last-of-type) {
    margin-bottom: 4px;
  }
  &[data-checked='true'] {
    background-color: var(--mantine-color-purple-1);
  }
`;
